
import React, { useState, useEffect } from 'react';
import { Button, Form, Input, InputNumber, message, Card, Select } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';
import courseService from '../../services/course.service';
import { Table, Popconfirm, Tooltip } from 'antd';
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';

const BadgeManager = ({ courseId }) => {
    const [threshold, setThreshold] = useState(10);
    const [badges, setBadges] = useState([]);
const [loadingBadges, setLoadingBadges] = useState(false);

    // const [studentName, setStudentName] = useState('');
    const [courseTitle, setCourseTitle] = useState('');
    const [score, setScore] = useState(0);
    const [loading, setLoading] = useState(false);
    const [savingThreshold, setSavingThreshold] = useState(false);

    const [studentName, setStudentName] = useState(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        return user?.username || "";
    });
    const [allUsers, setAllUsers] = useState([]);
    
            const fetchBadges = async () => {
    if (courseId) {
        try {
            setLoadingBadges(true);
            const res = await courseService.getBadgesByCourse(courseId);
            setBadges(res);
        } catch (err) {
            console.error("Erreur chargement badges :", err);
        } finally {
            setLoadingBadges(false);
        }
    }
};
    
    useEffect(() => {

        fetchBadges();
    }, [courseId]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const usernames = await courseService.getAllUsernames();
                setAllUsers(usernames);
            } catch (err) {
                console.error("Erreur lors de la récupération des utilisateurs :", err);
            }
        };

        fetchUsers();
    }, []);

    // Récupérer automatiquement le titre du cours si courseId est fourni
    useEffect(() => {
        const fetchCourseTitle = async () => {
            if (courseId) {
                try {
                    const course = await courseService.getCourseDetails(courseId);
                    setCourseTitle(course.title || '');
                } catch (error) {
                    console.error("Erreur lors de la récupération du titre du cours :", error);
                }
            }
        };

        fetchCourseTitle();
    }, [courseId]);
    useEffect(() => {
        const fetchCourseTitleAndThreshold = async () => {
            if (courseId) {
                try {
                    const course = await courseService.getCourseDetails(courseId);
                    setCourseTitle(course.title || '');

                    const thresholdFromDb = await courseService.getThreshold(courseId);
                    setThreshold(thresholdFromDb); // ⬅️ récupère depuis le back
                } catch (error) {
                    console.error("Erreur lors de la récupération du titre ou seuil :", error);
                }
            }
        };

        fetchCourseTitleAndThreshold();
    }, [courseId]);

    // *** premier logque de telecharger le badge directement 
  
    // const handleGenerate = async () => {
    //     if (!studentName || !courseTitle) {
    //         message.warning("Veuillez remplir tous les champs obligatoires.");
    //         return;
    //     }

    //     if (score < threshold) {
    //         message.warning(`Score insuffisant (${score}/${threshold}) pour générer le badge.`);
    //         return;
    //     }

    //     try {
    //         setLoading(true);

    //         const driveUrl = await courseService.getBadgeUrl(
    //             studentName.trim().split(" ")[0], // ← Utiliser seulement "Taoufik"
    //             parseInt(courseId),
    //             courseTitle,
    //             parseInt(score),
    //             parseInt(threshold)
    //         );


    //         if (driveUrl) {
    //             window.open(driveUrl, "_blank");
    //             message.success("🎖️ Badge généré ou récupéré avec succès !");
    //         } else {
    //             message.error("Erreur : le badge n’a pas pu être généré.");
    //         }
    //     } catch (error) {
    //         console.error("Erreur lors de la génération du badge :", error);
    //         message.error("Erreur lors de la génération du badge.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleGenerate = async () => {
    if (!studentName || !courseTitle) {
        message.warning("Veuillez remplir tous les champs obligatoires.");
        return;
    }

    if (score < threshold) {
        message.warning(`Score insuffisant (${score}/${threshold}) pour générer le badge.`);
        return;
    }

    try {
        setLoading(true);

        const driveUrl = await courseService.getBadgeUrl(
            studentName.trim().split(" ")[0],
            parseInt(courseId),
            courseTitle,
            parseInt(score),
            parseInt(threshold)
        );

        if (driveUrl) {
            window.open(driveUrl, "_blank");
            message.success("🎖️ Badge généré ou récupéré avec succès !");
            await fetchBadges(); // ✅ rechargement
        } else {
            message.error("Erreur : le badge n’a pas pu être généré.");
        }
    } catch (error) {
        console.error("Erreur lors de la génération du badge :", error);
        message.error("Erreur lors de la génération du badge.");
    } finally {
        setLoading(false);
    }
};

    return (
        <>
            <Card
                title={<><TrophyOutlined style={{ color: "#faad14" }} /> Gestion du Badge du Cours</>}
                bordered
                style={{ marginTop: 20 }}
            >
                <Form layout="vertical" onFinish={handleGenerate}>
                    <Form.Item label="👤 Nom de l'étudiant" required>
                        <Select
                            showSearch
                            placeholder="Choisissez un étudiant"
                            value={studentName}
                            onChange={setStudentName}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {allUsers.map((username) => (
                                <Select.Option key={username} value={username}>
                                    {username}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="📘 Titre du cours" required>
                        <Input value={courseTitle} />
                    </Form.Item>

                    <Form.Item label="🧮 Score de l'étudiant">
                        <InputNumber min={0} max={20} value={score} onChange={setScore} style={{ width: "100%" }} />
                    </Form.Item>

                    <Form.Item label="🎯 Seuil minimal pour obtenir le badge">
                        <div style={{ display: "flex", gap: "10px" }}>
                            <InputNumber
                                min={0}
                                max={20}
                                value={threshold}
                                onChange={setThreshold}
                                style={{ flex: 1 }}
                            />
                            {/* <Button
                                icon={<TrophyOutlined />}
                                onClick={async () => {
                                    try {
                                        await courseService.updateThreshold(courseId, threshold);
                                        message.success("✅ Seuil mis à jour !");
                                    } catch (error) {
                                        console.error("Erreur update seuil :", error);
                                        message.error("❌ Échec de mise à jour.");
                                    }
                                }}
                            >
                                Sauvegarder
                            </Button> */}
                            <Button
                                icon={<TrophyOutlined />}
                                loading={savingThreshold}
                                onClick={async () => {
                                    try {
                                        setSavingThreshold(true); // Start loading
                                        await courseService.updateThreshold(courseId, threshold);
                                        message.success("✅ Seuil mis à jour !");
                                    } catch (error) {
                                        console.error("Erreur update seuil :", error);
                                        message.error("❌ Échec de mise à jour.");
                                    } finally {
                                        setSavingThreshold(false); // Stop loading
                                    }
                                }}
                            >
                                Sauvegarder
                            </Button>

                        </div>
                    </Form.Item>

                    <Button type="primary" htmlType="submit" loading={loading} block>
                        Générer le badge
                    </Button>
                </Form>
            </Card>

            {badges.length > 0 && (
                // <Card title="🎓 Badges déjà générés" style={{ marginTop: 30 }}>
                <Card title={`🎓 Badges déjà générés (${badges.length})`} style={{ marginTop: 30 }}>

                    <Table
                        loading={loadingBadges} // ⬅️ ici le spinner

                        dataSource={badges}
                        rowKey="id"
                        pagination={{ pageSize: 5 }}
                        columns={[
                            {
                                title: '👤 Utilisateur',
                                dataIndex: ['user', 'username'],
                                key: 'username',
                                render: (text) => text || 'Inconnu',
                            },
                            {
                                title: '🏷️ Titre',
                                dataIndex: 'title',
                                key: 'title',
                            },
                            {
                                title: '🎯 Seuil',
                                dataIndex: 'threshold',
                                key: 'threshold',
                            },
                            {
                                title: '📅 Généré le',
                                dataIndex: 'generatedAt',
                                key: 'generatedAt',
                                render: (date) => new Date(date).toLocaleString(),
                            },
                            {
                                title: '🔗 Actions',
                                key: 'actions',
                                render: (_, badge) => (
                                    <div style={{ display: 'flex', gap: 8 }}>
                                        <Tooltip title="Voir le badge">
                                            <Button
                                                type="link"
                                                icon={<EyeOutlined />}
                                                href={badge.driveUrl}
                                                target="_blank"
                                            />
                                        </Tooltip>
                                        <Popconfirm
                                            title="Supprimer ce badge ?"
                                            onConfirm={async () => {
                                                try {
                                                    await courseService.deleteBadge(badge.id);
                                                    message.success("Badge supprimé !");
                                                    // setBadges((prev) =>
                                                    //     prev.filter((b) => b.id !== badge.id)
                                                    // );
                                                    const updated = await courseService.getBadgesByCourse(courseId);
                                                    setBadges(updated);

                                                } catch (err) {
                                                    message.error("Erreur lors de la suppression.");
                                                }
                                            }}
                                            okText="Oui"
                                            cancelText="Non"
                                        >
                                            <Tooltip title="Supprimer">
                                                <Button danger type="text" icon={<DeleteOutlined />} />
                                            </Tooltip>
                                        </Popconfirm>
                                    </div>
                                ),
                            },
                        ]}
                    />
                </Card>
            )}

        </>
    );

    // return (
    //     <Card
    //         title={<><TrophyOutlined style={{ color: "#faad14" }} /> Gestion du Badge du Cours</>}
    //         bordered
    //         style={{ marginTop: 20 }}
    //     >
    //         <Form layout="vertical" onFinish={handleGenerate}>
    //             {/* <Form.Item label="👤 Nom de l'étudiant" required>
    //                 <Input value={studentName} onChange={(e) => setStudentName(e.target.value)} />
    //             </Form.Item> */}
    //             <Form.Item label="👤 Nom de l'étudiant" required>
    //                 <Select
    //                     showSearch
    //                     placeholder="Choisissez un étudiant"
    //                     value={studentName}
    //                     onChange={setStudentName}
    //                     filterOption={(input, option) =>
    //                         option.children.toLowerCase().includes(input.toLowerCase())
    //                     }
    //                 >
    //                     {allUsers.map((username) => (
    //                         <Select.Option key={username} value={username}>
    //                             {username}
    //                         </Select.Option>
    //                     ))}
    //                 </Select>
    //             </Form.Item>

    //             <Form.Item label="📘 Titre du cours" required>
    //                 <Input value={courseTitle} />
    //             </Form.Item>

    //             <Form.Item label="🧮 Score de l'étudiant">
    //                 <InputNumber min={0} max={20} value={score} onChange={setScore} style={{ width: "100%" }} />
    //             </Form.Item>

    //             <Form.Item label="🎯 Seuil minimal pour obtenir le badge">
    //                 <div style={{ display: "flex", gap: "10px" }}>
    //                     <InputNumber
    //                         min={0}
    //                         max={20}
    //                         value={threshold}
    //                         onChange={setThreshold}
    //                         style={{ flex: 1 }}
    //                     />
    //                     <Button
    //                         icon={<TrophyOutlined />}
    //                         onClick={async () => {
    //                             try {
    //                                 await courseService.updateThreshold(courseId, threshold);
    //                                 message.success("✅ Seuil mis à jour !");
    //                             } catch (error) {
    //                                 console.error("Erreur update seuil :", error);
    //                                 message.error("❌ Échec de mise à jour.");
    //                             }
    //                         }}
    //                     >
    //                         Sauvegarder
    //                     </Button>
    //                 </div>
    //             </Form.Item>

    //             <Button type="primary" htmlType="submit" loading={loading} block>
    //                 Générer le badge
    //             </Button>
    //         </Form>
    //     </Card>




    // );
};

export default BadgeManager;
